module.exports = __webpack_public_path__ + "static/media/cancelled_active.26452c76.svg";